export default "__VITE_ASSET__BZAwpsxq__"